/* Nord�k - UI prototype + panier/checkout Shopify natifs */
(function () {
  var euro = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' ?'; };
  var state = { color: 'Noir', pack: '2 unites' };
  var V = window.NORDIK_VARIANTS || {};

  function variantId() { return V[state.color + '|' + state.pack]; }

  /* ---- Galerie ---- */
  var mainImg = document.getElementById('mainImg');
  var thumbs = [].slice.call(document.querySelectorAll('.thumb'));
  var imgs = thumbs.map(function (t) { return t.dataset.img; });
  var curr = 0;
  function setMain(i) {
    curr = (i + imgs.length) % imgs.length;
    if (mainImg) mainImg.src = imgs[curr];
    thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === curr); });
  }
  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { setMain(i); }); });

  /* Index de la photo correspondant � une couleur (pour basculer la galerie) */
  function imgIndexFor(token) {
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i] && imgs[i].toLowerCase().indexOf(token) !== -1) return i;
    }
    return -1;
  }

  /* ---- Lightbox (g�n�rique : galerie + photos d'avis + mosa�que UGC) ---- */
  var lb = document.getElementById('lightbox'), lbImg = document.getElementById('lightboxImg');
  var lbSet = imgs, lbIndex = 0;
  function showLb() { if (lbImg && lbSet.length) lbImg.src = lbSet[lbIndex]; }
  function openLb(set, index) {
    lbSet = set; lbIndex = (index + set.length) % set.length;
    showLb();
    if (lb) { lb.classList.add('open'); lb.setAttribute('aria-hidden', 'false'); }
  }
  function closeLb() { if (lb) { lb.classList.remove('open'); lb.setAttribute('aria-hidden', 'true'); } }
  function stepLb(d) { lbIndex = (lbIndex + d + lbSet.length) % lbSet.length; showLb(); }
  if (lb) {
    // Image principale de la galerie ? ouvre la galerie compl�te
    if (mainImg) mainImg.addEventListener('click', function () { openLb(imgs, curr); });
    // Photos d'avis + mosa�que UGC (PAS la section � En d�tail �) ? ouvre l'ensemble des avis
    var reviewEls = [].slice.call(document.querySelectorAll('.review-photo, .ugc-mosaic img'));
    var reviewSrcs = reviewEls.map(function (im) { return im.currentSrc || im.src; });
    reviewEls.forEach(function (im, i) {
      im.style.cursor = 'zoom-in';
      im.addEventListener('click', function () { openLb(reviewSrcs, i); });
    });
    document.getElementById('lightboxClose').addEventListener('click', closeLb);
    document.getElementById('lightboxPrev').addEventListener('click', function (e) { e.stopPropagation(); stepLb(-1); });
    document.getElementById('lightboxNext').addEventListener('click', function (e) { e.stopPropagation(); stepLb(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
  }

  /* ---- Couleur + livraison ---- */
  function months(d) { return ['janv.', 'f�vr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'ao�t', 'sept.', 'oct.', 'nov.', 'd�c.'][d]; }
  function range(min, max) {
    var a = new Date(); a.setDate(a.getDate() + min);
    var b = new Date(); b.setDate(b.getDate() + max);
    if (a.getMonth() === b.getMonth()) return a.getDate() + ' - ' + b.getDate() + ' ' + months(b.getMonth());
    return a.getDate() + ' ' + months(a.getMonth()) + ' - ' + b.getDate() + ' ' + months(b.getMonth());
  }
  function updateDelivery() {
    var blanc = /blanc/i.test(state.color), el = document.getElementById('deliveryDate');
    if (el) el.textContent = range(blanc ? 7 : 5, blanc ? 11 : 10);
  }
  function showColorImage() {
    var idx = imgIndexFor(/blanc/i.test(state.color) ? 'blanc' : 'noir');
    if (idx !== -1) setMain(idx);
  }
  document.querySelectorAll('#swatches .swatch').forEach(function (s) {
    s.addEventListener('click', function () {
      document.querySelectorAll('#swatches .swatch').forEach(function (x) { x.classList.remove('is-active'); });
      s.classList.add('is-active'); state.color = s.dataset.color;
      updateDelivery(); showColorImage();
    });
  });

  /* ---- Pack + prix ---- */
  function refreshPrice() {
    var b = document.querySelector('#bundles .bundle.is-active');
    if (!b) return;
    var p = euro(parseInt(b.dataset.price, 10));
    var a = document.getElementById('atcPrice'); if (a) a.textContent = p;
    var m = document.getElementById('mbPrice'); if (m) m.textContent = p;
  }
  document.querySelectorAll('#bundles .bundle').forEach(function (b) {
    b.addEventListener('click', function () {
      document.querySelectorAll('#bundles .bundle').forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active'); state.pack = b.dataset.pack; refreshPrice();
    });
  });

  /* ---- Panier Shopify ---- */
  var drawer = document.getElementById('cartDrawer'), overlay = document.getElementById('drawerOverlay');
  function openCart() { if (drawer) { drawer.classList.add('open'); overlay.classList.add('open'); } }
  function closeCart() { if (drawer) { drawer.classList.remove('open'); overlay.classList.remove('open'); } }
  var oc = document.getElementById('openCart'); if (oc) oc.addEventListener('click', function () { renderCart(); openCart(); });
  var cc = document.getElementById('closeCart'); if (cc) cc.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  function changeLine(key,qty){fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(function(){renderCart();});}
  function renderCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var box = document.getElementById('cartItems'), btn = document.getElementById('checkoutBtn');
      var cnt = document.getElementById('cartCount'), tot = document.getElementById('cartTotal');
      if (cnt) cnt.textContent = cart.item_count;
      if (tot) tot.textContent = euro(cart.total_price);
      if (!box) return;
      if (!cart.items.length) {
        box.innerHTML = '<p class="empty-cart">Ton panier est vide</p>';
        if (btn) btn.disabled = true; return;
      }
      box.innerHTML = cart.items.map(function (it) {
        return '<div class="cart-item"><img src="' + (it.image || '') + '" alt="" />' +
          '<div class="ci-info"><strong>' + it.product_title + '</strong>' +
          '<small>' + (it.variant_title || '') + '</small>' + '<div class="ci-qty" data-key="' + it.key + '" style="display:flex;align-items:center;gap:12px;margin-top:6px;flex-wrap:wrap;"><div style="display:inline-flex;align-items:center;border:1px solid rgba(255,255,255,.28);border-radius:8px;overflow:hidden;"><button type="button" class="ci-q" data-act="dec" aria-label="Diminuer" style="width:30px;height:30px;border:0;background:rgba(255,255,255,.08);color:#fff;font-size:17px;line-height:1;cursor:pointer;">&minus;</button><span class="ci-qv" style="min-width:30px;text-align:center;color:#fff;font-weight:600;font-size:14px;">' + it.quantity + '</span><button type="button" class="ci-q" data-act="inc" aria-label="Augmenter" style="width:30px;height:30px;border:0;background:rgba(255,255,255,.08);color:#fff;font-size:17px;line-height:1;cursor:pointer;">+</button></div><button type="button" class="ci-rm" data-act="rm" style="border:0;background:none;color:rgba(255,255,255,.6);font-size:12px;cursor:pointer;text-decoration:underline;">Retirer</button></div>' + '</div>' +
          '<div class="ci-price">' + euro(it.final_line_price) + '</div></div>';
      }).join('');
      box.querySelectorAll('.ci-qty').forEach(function(row){var key=row.getAttribute('data-key');var cur=parseInt(row.querySelector('.ci-qv').textContent,10)||1;row.querySelectorAll('[data-act]').forEach(function(b){b.addEventListener('click',function(){var a=b.getAttribute('data-act');var q=a==='inc'?cur+1:(a==='dec'?Math.max(1,cur-1):0);changeLine(key,q);});});}); if (btn) btn.disabled = false;
    });
  }

  function add(redirect) {
    var id = variantId();
    if (!id) { alert('S�lection indisponible.'); return; }
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) {
      if (!r.ok) { return r.json().then(function (e) { throw e; }); }
      return r.json();
    }).then(function () {
      if (redirect) { window.location.href = '/checkout'; }
      else { renderCart(); openCart(); }
    }).catch(function (e) {
      alert((e && e.description) || "Impossible d'ajouter au panier pour le moment, r�essaie dans un instant.");
    });
  }
  ['addToCart', 'addToCart2', 'addToCart3'].forEach(function (id) {
    var el = document.getElementById(id); if (el) el.addEventListener('click', function () { add(false); });
  });
  var bn = document.getElementById('buyNow'); if (bn) bn.addEventListener('click', function () { add(true); });
  var cb = document.getElementById('checkoutBtn'); if (cb) cb.addEventListener('click', function () { window.location.href = '/checkout'; });

  /* ---- FAQ ---- */
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var q = item.querySelector('.faq-q');
    if (q) q.addEventListener('click', function () { item.classList.toggle('open'); });
  });

  /* ---- Mode nuit ---- */
  (function () {
    var btn = document.getElementById('themeToggle'); if (!btn) return;
    function apply(dark) {
      document.body.classList.toggle('dark', dark);
      btn.textContent = dark ? '??' : '??';
    }
    var saved = localStorage.getItem('nordik_theme');
    var pref = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    apply(saved ? saved === 'dark' : pref);
    btn.addEventListener('click', function () {
      var dark = !document.body.classList.contains('dark');
      apply(dark); localStorage.setItem('nordik_theme', dark ? 'dark' : 'light');
    });
  })();

  /* ---- Cookies ---- */
  (function () {
    var banner = document.getElementById('cookieBanner'); if (!banner) return;
    if (!localStorage.getItem('nordik_cookies')) setTimeout(function () { banner.hidden = false; }, 1500);
    function close(c) { localStorage.setItem('nordik_cookies', c); banner.hidden = true; }
    var a = document.getElementById('cookieAccept'), r = document.getElementById('cookieRefuse');
    if (a) a.addEventListener('click', function () { close('accepted'); });
    if (r) r.addEventListener('click', function () { close('refused'); });
  })();

  /* ---- �chap ferme tiroir/lightbox ---- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeLb(); }
  });

  updateDelivery(); refreshPrice(); setMain(0); renderCart();
})();
